import { render, staticRenderFns } from "./ScheduleAluno.vue?vue&type=template&id=164af590"
import script from "./ScheduleAluno.vue?vue&type=script&lang=js"
export * from "./ScheduleAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports